import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'auth-one-id',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      maxWidth: 478,
      width: '100%',
      gap: 8,
      'button&, a&': {
        padding: theme.spacing(1.5),
        backgroundColor: theme.palette.common.white,
        color: '#4825C2',
        lineHeight: theme.spacing(3),
        '&:hover': {
          backgroundColor: theme.palette.light[800],
        },
      },
    },
  }),
  options
);

export default useStyles;
